import { Box } from "@/Components/v2/atoms/Box";
import { YellowButton } from "@/Components/v2/atoms/Button/YellowButton";
import { Card } from "@/Components/v2/atoms/Card";
import { Typography } from "@/Components/v2/atoms/Typography";
import { EnvVar } from "@/env";

export interface SentryErrorFallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}

function SentryErrorFallback({ error, resetError }: SentryErrorFallbackProps) {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          padding: 0,
          height: "100%",
          width: "100%",
        }}
      >
        <Card
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            height: "100%",
            padding: 0,
            margin: 0,
            boxShadow: "none",
            backgroundColor: "transparent",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: "100%",
                marginLeft: "20px",
                maxWidth: "300px",
                paddingTop: "30px",
                paddingBottom: "20px",
              }}
            >
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 900,
                  fontSize: "27px",
                }}
              >
                Uh oh
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  marginBottom: "20px",
                  marginTop: "10px",
                }}
              >
                Something unexpected happened
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "10px",
                  marginTop: "10px",
                }}
              >
                We&rsquo;re sorry, but something went wrong. Don&rsquo;t worry though - our team has
                been automatically notified and we&rsquo;re looking into it.
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "10px",
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
              >
                In the meantime, try refreshing the page or heading back to the dashboard.
              </Typography>

              <Box sx={{ margin: "5px" }}>
                <YellowButton
                  onClick={resetError}
                  sx={{
                    textTransform: "none",
                    fontWeight: 800,
                    fontSize: "13px",
                    marginTop: "10px",
                    padding: "7px 20px",
                  }}
                >
                  Try Again
                </YellowButton>
              </Box>

              {EnvVar.envName !== "production" && (
                <details style={{ marginTop: "20px" }}>
                  <summary
                    style={{
                      cursor: "pointer",
                      marginBottom: "8px",
                      fontSize: "10px",
                      fontWeight: 600,
                    }}
                  >
                    Error details
                  </summary>
                  <pre
                    style={{
                      fontSize: "9px",
                      backgroundColor: "#f5f5f5",
                      padding: "8px",
                      borderRadius: "4px",
                      overflow: "auto",
                      whiteSpace: "pre-wrap",
                      wordBreak: "break-word",
                      maxWidth: "280px",
                    }}
                  >
                    {error instanceof Error ? error.toString() : String(error)}
                  </pre>
                </details>
              )}
            </Box>
          </Box>
        </Card>
      </Box>
    </Box>
  );
}

export default SentryErrorFallback;
